import { useInfiniteQuery } from "@tanstack/react-query";
import { agencySaleDetail } from "../../services/agencies-sales-details";
import { AGENCIES_SALES_DETAILS_QUERY_KEY, SalesHistoryFilters } from "./use-get-agencies-sales-details";

const PAGE_SIZE = 20;

// Seller statement (sales + conversions + every other stock movement), newest
// first, infinite scroll. Pages by ledger rows read (`ledgerRows`): the server can
// add "unrecorded" rows next to them. Key under the list key, so a sale or a
// reversal refreshes it.
export const useGetAgencySellerStatement = (filters: SalesHistoryFilters = {}) => {
  const query = useInfiniteQuery({
    queryKey: [AGENCIES_SALES_DETAILS_QUERY_KEY, "statement", filters],
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      agencySaleDetail.getStatement({ take: PAGE_SIZE, skip: pageParam as number, ...filters }),
    getNextPageParam: (lastPage, allPages) =>
      (lastPage?.data?.ledgerRows ?? 0) < PAGE_SIZE ? undefined : allPages.length * PAGE_SIZE,
  });

  const rows = query.data?.pages.flatMap((page) => page?.data?.rows ?? []) ?? [];
  const balanceMode = query.data?.pages[0]?.data?.balanceMode ?? true;

  return {
    rows,
    balanceMode,
    isLoading: query.isLoading,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
  };
};
